import './bontempsgrill/style';
import FormStructure from './bontempsgrill/form_structure';

export default FormStructure;